(function() {
'use strict';

angular
    .module('TR')
    .service('commonErrors', commonErrors);

function commonErrors($q, $location, currentUser) {
    const service = {
        0: zero,
        400: fourHundred,
        404: fourOFour,
        401: fourOOne,
        410: fourTen
    };

    function _notFound(data) {
        const area = $location.path().split('/')[1];
        const supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(p => p.toLowerCase());
        if (data && data.config && data.config.url) {
            logError(data.config.url);
        }
        const areaSupported = supportedProducts.indexOf(area.toLowerCase()) > -1;

        switch (area) {
            case area:
                areaSupported
                    ? $location.path(`${area}/notfound`)
                    : $location.path('holidays/notfound');
                break;

            default:
                $location.path('holidays/notfound');
        }
    }

    function zero() {
        return $q.reject('CANCELLED');
    }

    function logError(url) {
        const utm = currentUser.get().UtmId;
        $.ajax({
            type: 'POST',
            url: 'website/logging/log',
            contentType: 'application/json',
            data: JSON.stringify({
                Message: `Customer with utmId ${utm} received a 404 from ${url}`,
                LogLevel: 2 // Warning
            })
        });
    }

    function fourHundred(data) {
        $location.path('error');

        return $q.reject(data);
    }

    function fourOOne(data) {
        const path = $location.path();
        const absUrl = $location.absUrl();
        const redirectUrl = String.format(TRPCONFIG.Domain.AgentLogonUrl, absUrl);

        if (data && data.headers && data.headers()['www-authenticate']) {
            if (data.headers()['www-authenticate'].indexOf('realm="Agent"') > -1 && (path !== '/agents/signin')) {
                window.location.href = redirectUrl;
            }
        }

        return $q.reject(data);
    }

    function fourOFour(data) {
        _notFound(data);

        return $q.reject(data);
    }

    function fourTen(data) {
        _notFound(data);

        return $q.reject(data);
    }

    return service;
}
})();
